import React, { useState, useRef } from 'react';
import './DragAndDropFiles.style.css';

const DragAndDropFiles = ({
  accept = '*',
  children,
  multiple = false,
  style = {},
  onChange = () => {},
}) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  /* ===== State ===== */
  const fileInputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [isFocus, setIsFocus] = useState(false);

  /* ===== Hooks ===== */
  /* ===== Function ===== */
  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (!multiple && e.dataTransfer.files.length > 1) {
      return false;
    }
    handleFileChange(e.dataTransfer.files);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer.files) {
      setIsDragging(true);
    }
  };

  const handleFileChange = (e) => {
    onChange && onChange(e);
  };

  const triggerFileSelect = () => fileInputRef.current.click();

  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  return (
    <div
      className="drag_container"
      onMouseEnter={() => setIsFocus(true)}
      onMouseLeave={() => setIsFocus(false)}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragEnter={handleDragEnter}
      onDragLeave={handleDragLeave}
      onClick={triggerFileSelect}
      style={{
        borderColor: isDragging || isFocus ? 'var(--primary-color)' : '#F4F4F5',
        ...style,
      }}
    >
      <input
        ref={fileInputRef}
        type="file"
        accept={accept}
        multiple={multiple}
        aria-hidden
        onChange={(e) => handleFileChange(e.target.files)}
        style={{ display: 'none' }}
      />
      {children}
    </div>
  );
};

export default DragAndDropFiles;
